<div class="banner-constructora position-relative mt-5">
  <div class="logo-banner-constructora">
    <img [src]="profile.image || '/assets/img/loading-img.gif'" alt="" style="width: auto; height: 100px;" />
  </div>
  <img
    [src]="profile.banner ? profile.banner : './assets/img/constructoras/banner-constructora-2.jpg'"
    alt=""
    class="img-fluid img-banner-constructora"
  />
</div>

<section class="container py-3 text-center text-lg-left">
  <h2  *ngIf="version" class="text-red font-weight-bold text-center">{{profile.name}}</h2>

  <div class="row">
    <div *ngIf="profile.description" class="col-6 col-lg-3 mb-3 mb-lg-0">
      <div class="row align-items-center">
        <div class="col-lg-3">
          <div class="text-center">
            <img
              src="/assets/img/constructoras/icon-building.svg"
              alt=""
              class="img-fluid"
            />
          </div>
        </div>
        <div class="col-lg-9 px-0">
          <h6 class="mb-0 font-weight-bold">La constructora</h6>
          <div class="row align-items-center">
            <div class="col-9 pr-0">
              <h6 class="mb-0 font-weight-normal text-truncate">{{profile.description}}</h6>
            </div>
            <div class="col-3 pl-0">
              <div class="btn-group dropright">
                <button type="button" class="btn text-red p-0 dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
                  más
                </button>
                <div class="dropdown-menu" style="min-width: 280px;">
                  <div class="px-2 py-1">
                  {{profile.description}}
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          
        </div>
      </div>
    </div>
    <div *ngIf="profile.cellphones?.length > 0" class="col-6 col-lg-2 mb-3 mb-lg-0">
      <div class="row align-items-center">
        <div class="col-lg-3">
          <div class="text-center">
            <img
              src="/assets/img/constructoras/icon-cellphone.svg"
              alt=""
              class="img-fluid"
            />
          </div>
        </div>
        <div class="col-lg-9 px-0">
          <h6 class="mb-0 font-weight-bold">Celular</h6>
          <h6 class="mb-0 font-weight-normal">{{profile.cellphones[0]}}</h6>
        </div>
      </div>
    </div>
    <!-- <div *ngIf="profile.phones" class="col-6 col-lg-3">
      <div class="row align-items-center">
        <div class="col-lg-3">
          <div class="text-center">
            <img
              src="/assets/img/constructoras/icon-phone.svg"
              alt=""
              class="img-fluid"
            />
          </div>
        </div>
        <div class="col-lg-9 px-0">
          <h6 class="mb-0 font-weight-bold">Teléfono</h6>
          <h6 class="mb-0 font-weight-normal">{{profile.phone}}</h6>
        </div>
      </div>
    </div> -->
    <div *ngIf="profile.locations?.length > 0 " class="col-6 col-lg-4">
      <div class="row align-items-center">
        <div class="col-lg-3">
          <div class="text-center">
            <img
              src="/assets/img/constructoras/icon-building.svg"
              alt=""
              class="img-fluid"
            />
          </div>
        </div>
        <div class="col-lg-9 px-0">
          <h6 class="mb-0 font-weight-bold">Dirección</h6>
          <h6 class="mb-0 font-weight-normal small">{{ profile.locations[0]?.address}}</h6>
        </div>
      </div>
    </div>
    <!-- <div *ngIf="profile.locations.length > 0 " class="col-6 col-lg-3">
      <div class="row align-items-center">
        <div class="col-lg-3">
          <div class="text-center">
            <img
              src="/assets/img/constructoras/icon-building.svg"
              alt=""
              class="img-fluid"
            />
          </div>
        </div>
        <div class="col-lg-9 px-0">
          <h6 class="mb-0 font-weight-bold">Ubicación</h6>
          <h6 class="mb-0 font-weight-normal">{{ profile.locations[0]?.city}}</h6>
        </div>
      </div>
    </div> -->

    <div *ngIf="profile.locations?.length > 0 " class="col-6 col-lg-3">
      <div class="row align-items-center">
        <div class="col-lg-3">
          <div class="text-center">
            <img
              src="/assets/img/constructoras/icon-building.svg"
              alt=""
              class="img-fluid"
            />
          </div>
        </div>
        <div class="col-lg-9 px-0">
          <h6 class="mb-0 font-weight-bold">Contacto</h6>
          <h6 class="mb-0 font-weight-normal">{{ profile.websites[0]}}</h6>
          <h6 class="mb-0 font-weight-normal">{{ profile.email}}</h6>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="container pb-2">
  <h2  *ngIf="!version" class="text-red font-weight-bold text-center">{{profile.name}}</h2>

  <div class="row">
    <div class="col-lg-3" *ngIf="!version">
      <!-- filtros -->

      <h4 class="text-red font-weight-bold">Filtros</h4>

      <div class="form-group">
        <input
          type="text"
          class="form-control w-100 rounded"
          placeholder="Ciudad, sector, barrio, sitio de interés..."
        />
      </div>

      <div class="form-group">
        <h5 class="mb-0">Tipo de inmueble</h5>
        <select class="form-control w-100 rounded" name="property-type">
          <option value="" selected disabled>Tipo de inmueble</option>
        </select>
      </div>

      <div class="form-group">
        <h5 class="">Precio</h5>
        <div class="row">
          <div class="col-lg-6">
            <div class="small text-secondary font-weight-bold">Desde</div>
            <input
              type="text"
              class="form-control w-100 rounded mt-0"
              placeholder="2.000.000"
            />
          </div>
          <div class="col-lg-6">
            <div class="small text-right text-secondary font-weight-bold">
              Hasta
            </div>
            <input
              type="text"
              class="form-control w-100 rounded mt-0"
              placeholder="5.000.000.000"
            />
          </div>
        </div>
      </div>

      <div class="accordion" id="accordionFilters">
        <div class="">
          <button
            class="btn border-top w-100 text-left font-weight-bold"
            type="button"
            data-toggle="collapse"
            data-target="#collapseOne"
            aria-expanded="true"
            aria-controls="collapseOne"
          >
            Ordenar por

            <div class="float-right">
              <i class="fa" aria-hidden="true"></i>
            </div>
          </button>

          <div
            id="collapseOne"
            class="collapse show border-top"
            aria-labelledby="headingOne"
            data-parent="#accordionFilters"
          >
            <div class="p-2">
              <p class="mb-2">
                <a href="javascript:void(0)" class="text-dark">
                  Menor a mayor
                </a>
              </p>
              <p class="mb-2">
                <a href="javascript:void(0)" class="text-dark">
                  Mayor a menor
                </a>
              </p>
              <p class="text-blue font-weight-bold mb-1">Área</p>
            </div>
          </div>
        </div>

        <div class="">
          <button
            class="btn border-top w-100 text-left font-weight-bold collapsed"
            type="button"
            data-toggle="collapse"
            data-target="#collapseTwo"
            aria-expanded="false"
            aria-controls="collapseTwo"
          >
            Habitaciones

            <div class="float-right">
              <i class="fa" aria-hidden="true"></i>
            </div>
          </button>

          <div
            id="collapseTwo"
            class="collapse border-top"
            aria-labelledby="headingTwo"
            data-parent="#accordionFilters"
          >
            <div class="p-2">
              <div
                class="form-check d-flex align-items-center mb-1"
                *ngFor="let check of [1, 2, 3, 4, 5]"
              >
                <input
                  class="form-check-input"
                  type="checkbox"
                  value=""
                  id="roomsCheck{{ check }}"
                  name="roomsCheck"
                />
                <label
                  class="form-check-label mr-1"
                  for="roomsCheck{{ check }}"
                ></label>

                <label class="form-check-label" for="roomsCheck{{ check }}">
                  {{ check }} Habitaci{{ check == 1 ? "ón" : "ones" }}</label
                >
              </div>

              <div class="form-check d-flex align-items-center mb-1">
                <input
                  class="form-check-input"
                  type="checkbox"
                  value=""
                  id="roomsCheckPlus"
                  name="roomsCheck"
                />
                <label
                  class="form-check-label mr-1"
                  for="roomsCheckPlus"
                ></label>

                <label class="form-check-label" for="roomsCheckPlus">
                  + 5 Habitaciones</label
                >
              </div>
            </div>
          </div>
        </div>

        <div class="">
          <button
            class="btn border-top w-100 text-left font-weight-bold collapsed"
            type="button"
            data-toggle="collapse"
            data-target="#collapseThree"
            aria-expanded="false"
            aria-controls="collapseThree"
          >
            Baños
            <div class="float-right">
              <i class="fa" aria-hidden="true"></i>
            </div>
          </button>

          <div
            id="collapseThree"
            class="collapse border-top"
            aria-labelledby="headingThree"
            data-parent="#accordionFilters"
          >
            <div class="p-2">
              <div
                class="form-check d-flex align-items-center mb-1"
                *ngFor="let check of [1, 2, 3]"
              >
                <input
                  class="form-check-input"
                  type="checkbox"
                  value=""
                  id="bathroomsCheck{{ check }}"
                  name="bathroomsCheck"
                />
                <label
                  class="form-check-label mr-1"
                  for="bathroomsCheck{{ check }}"
                ></label>

                <label class="form-check-label" for="bathroomsCheck{{ check }}">
                  {{ check }} Baño{{ check == 1 ? "" : "s" }}</label
                >
              </div>

              <div class="form-check d-flex align-items-center mb-1">
                <input
                  class="form-check-input"
                  type="checkbox"
                  value=""
                  id="bathroomsCheckPlus"
                  name="bathroomsCheck"
                />
                <label
                  class="form-check-label mr-1"
                  for="bathroomsCheckPlus"
                ></label>

                <label class="form-check-label" for="bathroomsCheckPlus">
                  + 3 Baños</label
                >
              </div>
            </div>
          </div>
        </div>

        <div class="">
          <button
            class="btn border-top w-100 text-left font-weight-bold collapsed"
            type="button"
            data-toggle="collapse"
            data-target="#collapseFour"
            aria-expanded="false"
            aria-controls="collapseFour"
          >
            Parqueaderos
            <div class="float-right">
              <i class="fa" aria-hidden="true"></i>
            </div>
          </button>

          <div
            id="collapseFour"
            class="collapse border-top"
            aria-labelledby="headingFour"
            data-parent="#accordionFilters"
          >
            <div class="p-2">
              <div
                class="form-check d-flex align-items-center mb-1"
                *ngFor="let check of [1, 2]"
              >
                <input
                  class="form-check-input"
                  type="checkbox"
                  value=""
                  id="parkingCheck{{ check }}"
                  name="parkingCheck"
                />
                <label
                  class="form-check-label mr-1"
                  for="parkingCheck{{ check }}"
                ></label>

                <label class="form-check-label" for="parkingCheck{{ check }}">
                  {{ check }} Parqueadero{{ check == 1 ? "" : "s" }}</label
                >
              </div>

              <div class="form-check d-flex align-items-center mb-1">
                <input
                  class="form-check-input"
                  type="checkbox"
                  value=""
                  id="parkingCheckPlus"
                  name="parkingCheck"
                />
                <label
                  class="form-check-label mr-1"
                  for="parkingCheckPlus"
                ></label>

                <label class="form-check-label" for="parkingCheckPlus">
                  + 2 Parqueaderos
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="">
          <button
            class="btn border-top w-100 text-left font-weight-bold collapsed"
            type="button"
            data-toggle="collapse"
            data-target="#collapseFive"
            aria-expanded="false"
            aria-controls="collapseFive"
          >
            Estrato
            <div class="float-right">
              <i class="fa" aria-hidden="true"></i>
            </div>
          </button>

          <div
            id="collapseFive"
            class="collapse border-top"
            aria-labelledby="headingFive"
            data-parent="#accordionFilters"
          >
            <div class="p-2">
              <div
                class="form-check d-flex align-items-center mb-1"
                *ngFor="let check of [1, 2, 3, 4, 5, 6]"
              >
                <input
                  class="form-check-input"
                  type="checkbox"
                  value=""
                  id="estratoCheck{{ check }}"
                  name="estratoCheck"
                />
                <label
                  class="form-check-label mr-1"
                  for="estratoCheck{{ check }}"
                ></label>

                <label class="form-check-label" for="estratoCheck{{ check }}">
                  Estrato {{ check }}</label
                >
              </div>
            </div>
          </div>
        </div>

        <div class="">
          <button
            class="btn border-top w-100 text-left font-weight-bold collapsed"
            type="button"
            data-toggle="collapse"
            data-target="#collapseSix"
            aria-expanded="false"
            aria-controls="collapseSix"
          >
            Área (m<sup>2</sup>)
            <div class="float-right">
              <i class="fa" aria-hidden="true"></i>
            </div>
          </button>

          <div
            id="collapseSix"
            class="collapse border-top"
            aria-labelledby="headingSix"
            data-parent="#accordionFilters"
          >
            <div class="p-2">
              <div class="form-group">
                <div class="row">
                  <div class="col-lg-6">
                    <div class="small text-secondary font-weight-bold">
                      Desde
                    </div>
                    <select
                      class="form-control w-100 rounded mt-0"
                      name="area-from"
                    >
                      <option value="" selected disabled>Desde</option>
                      <option
                        value="{{ area }}"
                        *ngFor="let area of [60, 100, 200, 300, 400, 500, 1200]"
                      >
                        {{ area }} m2 {{ areas == 1200 ? "+" : "" }}
                      </option>
                    </select>
                  </div>
                  <div class="col-lg-6">
                    <div
                      class="small text-right text-secondary font-weight-bold"
                    >
                      Hasta
                    </div>
                    <select
                      class="form-control w-100 rounded mt-0"
                      name="area-to"
                    >
                      <option value="" selected disabled>Hasta</option>
                      <option
                        value="{{ area }}"
                        *ngFor="let area of [100, 200, 300, 400, 500, 1200]"
                      >
                        {{ area }} m2 {{ areas == 1200 ? "+" : "" }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="">
          <button
            class="btn border-top w-100 text-left font-weight-bold collapsed"
            type="button"
            data-toggle="collapse"
            data-target="#collapseSeven"
            aria-expanded="false"
            aria-controls="collapseSeven"
          >
            Lo quiero con
            <div class="float-right">
              <i class="fa" aria-hidden="true"></i>
            </div>
          </button>

          <div
            id="collapseSeven"
            class="collapse border-top"
            aria-labelledby="headingSeven"
            data-parent="#accordionFilters"
          >
            <div class="p-2">
              <div
                class="form-check d-flex align-items-center mb-1"
                *ngFor="
                  let check of ['Aire acondicionado', 'Balcón', 'Chimenea'];
                  let i;
                  as: index
                "
              >
                <input
                  class="form-check-input"
                  type="checkbox"
                  value=""
                  id="wantwithCheck{{ i }}"
                  name="wantwithCheck"
                />
                <label
                  class="form-check-label mr-1"
                  for="wantwithCheck{{ i }}"
                ></label>

                <label class="form-check-label" for="wantwithCheck{{ i }}">
                  {{ check }}</label
                >
              </div>
            </div>
          </div>
        </div>

        <div class="">
          <button
            class="btn border-top w-100 text-left font-weight-bold collapsed"
            type="button"
            data-toggle="collapse"
            data-target="#collapseEight"
            aria-expanded="false"
            aria-controls="collapseEight"
          >
            Fecha de publicación
            <div class="float-right">
              <i class="fa" aria-hidden="true"></i>
            </div>
          </button>

          <div
            id="collapseEight"
            class="collapse border-top"
            aria-labelledby="headingEight"
            data-parent="#accordionFilters"
          >
            <div class="p-2">
              <div class="form-group">
                <div class="row">
                  <div class="col-lg-6">
                    <div class="small text-secondary font-weight-bold">
                      Desde
                    </div>
                    <input
                      type="date"
                      class="form-control w-100 rounded mt-0"
                      name="publish-date-from"
                    />
                  </div>
                  <div class="col-lg-6">
                    <div
                      class="small text-right text-secondary font-weight-bold"
                    >
                      Hasta
                    </div>
                    <input
                      type="date"
                      class="form-control w-100 rounded mt-0"
                      name="publish-date-to"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-2">
        <button class="btn btn-red btn-rounded w-100 font-italic">
          <small> APLICAR FILTROS </small>
        </button>

        <button
          class="btn bg-secondary btn-rounded w-100 font-italic text-white mt-2"
        >
          <small> BORRAR FILTROS </small>
        </button>
      </div>
    </div>

    <div [class]="!version ? 'col-lg-9' : 'col-lg-12'">
      <!-- content -->
      <ul
      *ngIf="!version"
        class="nav justify-content-center border-bottom"
        id="tabFilter"
        role="tablist"
      >
        <li
          class=""
          role="presentation"
          *ngFor="let tab of tabFilter; let key = index"
        >
          <a
            class="nav-link text-red font-weight-bold {{
              key == 0 ? 'active' : ''
            }}"
            id="{{ tab.value }}-tab"
            data-toggle="tab"
            type="button"
            (click)="filterTabBy(tab.value)"
          >
            {{ tab.name }}
          </a>
        </li>
      </ul>

      <div class="row justify-content-between small" [class]="version ? 'mb-2 pb-2 border-bottom border-secondary' : 'my-2'">
        <div class="col">
          <div class="text-red"><b>00</b> resultados de <b>{{projects.length}}</b></div>
        </div>
        <div class="col">
          <div class="text-right">
            <a href="#" class="text-red font-weight-bold"
              ><i class="far fa-map"></i> Buscar en mapa</a
            >
          </div>
        </div>
      </div>
      
      <div class="row" *ngIf="profile.name && projects?.length == 0">
        No se encontraron proyectos
      </div>
      <div class="row" *ngIf="profile.name; else loading">
        <div [class]="!version ? 'col-lg-4' : 'col-lg-3'" *ngFor="let project of projects; let i = index">
          <div class="card mb-3">
            <img
              [src]="project.image || '/assets/img/loading-img.gif'"
              class="card-img-top"
              alt=""
            />
            <div class="card-info-company">
              <div class="row align-items-center">
                <div class="col-5">
                  <div class="card-logo text-center">
                    <img
                      [src]="profile.image"
                      alt=""
                      class="img-fluid"
                    />
                  </div>
                </div>
                <div class="col-6">
                  <div class="card-stage text-center">
                    <div class="btn-small btn-rounded bg-blue small text-white">
                      Sobre planos
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card-body pt-1 pb-2">
              <h6 *ngIf="version" class="text-blue font-weight-bold text-center mb-1" [title]="project.name || 'Nombre del proyecto'">
                {{ project.name || 'Nombre del Proyecto'}}
              </h6>
              <h5 class="text-red font-weight-bold text-center mb-1" *ngIf="!version">
                {{project.currency}} {{project.amount}}
              </h5>
              <h6 class="text-center text-truncate  text-capitalize mb-1">
                {{project.zone}}
              </h6>

              <div class="row justify-content-between small font-weight-bold">
                <div class="col-9 pl-0">
                  <div class="font-italic">{{project.address}}</div>
                </div>
                <div class="col-3 px-0">
                  <div class="row">
                    <div class="col-2 px-0">
                      <img
                        src="./assets/img/constructoras/icon-bed.svg"
                        alt=""
                        width="15px"
                        class="img-fluid"
                      />
                    </div>
                    <div class="col-8 pl-0 pr-1 text-right">2 {{ version ? 'Apt' : 'Hab'}}</div>
                  </div>
                </div>
              </div>

              <div *ngIf="!version" class="row justify-content-between small font-weight-bold">
                <div class="col-3 offset-9 px-0">
                  <div class="row">
                    <div class="col-2 px-0">
                      <img
                        src="./assets/img/constructoras/icon-shower.svg"
                        alt=""
                        width="15px"
                        class="img-fluid"
                      />
                    </div>
                    <div class="col-8 pl-0 pr-1 text-right">1 Baños</div>
                  </div>
                </div>
              </div>

              <div class="row justify-content-between small">
                <div class="col-9 pl-0">
                  <div class="font-italic">
                    <u>{{project.type}}{{ project.type && version ? 's en venta' : 'en venta'}}</u>
                  </div>
                </div>
                <div class="col-3 px-0">
                  <div class="row">
                    <div class="col-2 px-0">
                      <img
                        src="./assets/img/constructoras/icon-area.svg"
                        alt=""
                        width="15px"
                        class="img-fluid"
                      />
                    </div>
                    <div class="col-8 pl-0 pr-1 text-right font-weight-bold">
                      47 m<sup>2</sup>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mt-2">
                <button class="btn btn-blue btn-rounded w-100 font-italic">
                  <small> CONTACTAR </small>
                </button>

                <a class="btn btn-red btn-rounded w-100 font-italic mt-2"
                    [href]="version ? '/constructoras/'+ slug + '/proyecto/' + project.slug + '?v=2' : '/constructoras/'+ slug + '/proyecto/' + project.slug"
                >
                  <small> VER PROYECTO </small>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div [class]="!version ? 'd-none' : 'col-lg-3'" *ngFor="let project of [1,2,3,4,5,6,7,8,9,10]; let i = index">
          <div class="card mb-3">
            <img
              [src]="project.image || 'https://vivienda.s3.us-east-2.amazonaws.com/properties/MDQ4NjI3MWUtZWI1Yy00ZTlhLWE2ODQtYWM0YWQ0MjUzMDVk/0486271e-eb5c-4e9a-a684-ac4ad425305d/thumbs/54d11963-96e9-488e-aa66-a2200280b7f3/16/9/w180/h100/thumbnail.jpeg'"
              class="card-img-top"
              alt=""
            />
            <div class="card-info-company">
              <div class="row align-items-center">
                <div class="col-5">
                  <div class="card-logo text-center">
                    <img
                      [src]="profile.image"
                      alt=""
                      class="img-fluid"
                    />
                  </div>
                </div>
                <div class="col-6">
                  <div class="card-stage text-center">
                    <div class="btn-small btn-rounded bg-blue small text-white">
                      Sobre planos
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card-body pt-1 pb-2">
              <h6 *ngIf="version" class="text-blue font-weight-bold text-center mb-1" [title]="project.name || 'Austro de Cuatro Vientos'">
                {{ project.name || 'Austro de Cuatro Vientos'}}
              </h6>
              <h6 class="text-center text-truncate  text-capitalize mb-1">
                Bogotá
              </h6>

              <div class="row justify-content-between small font-weight-bold">
                <div class="col-9 pl-0">
                  <div class="font-italic">Bogotá, D.C.</div>
                </div>
                <div class="col-3 px-0">
                  <div class="row">
                    <div class="col-2 px-0">
                      <img
                        src="./assets/img/constructoras/icon-bed.svg"
                        alt=""
                        width="15px"
                        class="img-fluid"
                      />
                    </div>
                    <div class="col-8 pl-0 pr-1 text-right">2 {{ version ? 'Apt' : 'Hab'}}</div>
                  </div>
                </div>
              </div>

              <div class="row justify-content-between small">
                <div class="col-9 pl-0">
                  <div class="font-italic">
                    <u>Apartamentos en venta</u>
                  </div>
                </div>
                <div class="col-3 px-0">
                  <div class="row">
                    <div class="col-2 px-0">
                      <img
                        src="./assets/img/constructoras/icon-area.svg"
                        alt=""
                        width="15px"
                        class="img-fluid"
                      />
                    </div>
                    <div class="col-8 pl-0 pr-1 text-right font-weight-bold">
                      47 m<sup>2</sup>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mt-2">
                <button class="btn btn-blue btn-rounded w-100 font-italic">
                  <small> CONTACTAR </small>
                </button>

                <a class="btn btn-red btn-rounded w-100 font-italic mt-2"
                    [href]="version ? '/constructoras/'+ slug + '/proyecto/' + project.slug + '?v=2' : '/constructoras/'+ slug + '/proyecto/' + project.slug"
                >
                  <small> VER PROYECTO </small>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="my-2 text-center" *ngIf="projects?.length > 12">
        <a
          class="btn btn-red-outline btn-rounded px-5 font-weight-bold font-italic"
        >
          <span class="px-4"> CARGAR MÁS RESULTADOS</span>
        </a>
      </div>

      <!-- end content -->
    </div>
  </div>
</section>

<ng-template #loading>
  <div class="emptyBlock p-5 text-center">
    <div class="lds-spinner">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</ng-template>